import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">M. Faseeh Hassan</span>{" "}
            from <span className="purple">Chakwal, Pakistan.</span>
            <br />I have completed my Bachelor's degree in Computer Science from
            the
            <span className="purple"> University of Chakwal</span>.
            <br />
            <br />
            Apart from coding, here are a few things I enjoy doing in my free
            time:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to Music
            </li>
            <li className="about-activity">
              <ImPointRight /> Swimming
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Faseeh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
